<template>
  <div class="product-detail">
  </div>
</template>

<script>
import { geturl } from '@/utils/index';
export default {
  data() {
    return {
    }
  },
  created() {
    let params = geturl()
    this.getWechatCode(params.website);
    if (params.wechatDocumentId) {
      localStorage.setItem('wechatDocumentId', params.wechatDocumentId);
    } else {
      localStorage.setItem('wechatDocumentId', '');
    }
  },
  methods: {
    // 获取微信code
    getWechatCode(val) {
      var uri = 'https://api.weixin.54zkjl.com/weixin/#/open'
      var appid = 'wxfbb0dfe952434c83';
      var url = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' +
        encodeURIComponent(uri) + '&response_type=code&scope=snsapi_userinfo&state=' + val + '#wechat_redirect';
      window.location.href = url;
    }
  },
}
</script>
 
<style lang = "less" scoped></style>